// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import PasswordChangeModal from 'Containers/PasswordChange/PasswordChangeModal';

const StyledPasswordChangePage = styled.div`
  width: 100vw;
  height: 100vh;
`;

const PasswordChangePage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let passwordChangePageClassName = bodyAttributes?.class || '';
  if (!passwordChangePageClassName.includes('PasswordChangePage')) {
    passwordChangePageClassName += 'PasswordChangePage';
  }

  return (
    <>
      <Helmet>
        <body className={ passwordChangePageClassName } />
        <title>{ t('common.pages.passwordChange') }</title>
      </Helmet>
      <StyledPasswordChangePage theme={ theme } className="grid-container">
        <PasswordChangeModal />
      </StyledPasswordChangePage>
    </>
  );
});
PasswordChangePage.displayName = 'PasswordChangePage';

export default PasswordChangePage;
